import { httpServer as request } from '@/interceptors/http'

const apiUri = {
  // 企业微信免密登录
  postLogin: '/fhz-iam/anon/qywx/login',
  judgeDetail: '/fhz-material/sample/mass/judge/get', // 海选详情
  surveyDetail: '/fhz-material/sample/user/survey/cus/get', // 客户调研详情
  judgeUpdate: '/fhz-material/sample/mass/judge/update', // 海选新增或更新
  pageUserSurvey: '/fhz-material/sample/user/survey/pageUserSurvey', // 试样品编号查询
  cusSaveOrUpdate: '/fhz-material/sample/user/survey/cus/saveOrUpdate', // 调研新增或更新
}

// 企业微信免密登录
export function postLogin(params) {
  return request.post(apiUri.postLogin, params)
}

// 海选评审详情
export function getJudgeDetail(params) {
  return request.get(apiUri.judgeDetail, params)
}

// 客户调研详情
export function getSurveyDetail(params) {
  return request.get(apiUri.surveyDetail, params)
}

// 海选新增或更新
export function judgeUpdate(params) {
  return request.post(apiUri.judgeUpdate, params)
}

// 试样品编号查询
export function pageUserSurvey(params) {
  return request.post(apiUri.pageUserSurvey, params)
}

// 调研新增或更新
export function cusSaveOrUpdate(params) {
  return request.post(apiUri.cusSaveOrUpdate, params)
}
